import { useCallback, useEffect, useState } from 'react';

const UseScroll = () => {
  const [scrollTop, setScrollTop] = useState(0);
  const onScroll = useCallback(() => {
    setScrollTop(document.documentElement.scrollTop);
  }, []);
  useEffect(() => {
    window.addEventListener('scroll', onScroll, false);
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);
  return scrollTop;
};

export default UseScroll;
